import { SwiperDirective } from "@/directives/swiper/swiper.directive";
import { TooltipDirective } from "@/directives/tooltip/tooltip.directive";
import { NgFor } from "@angular/common";
import {
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  ElementRef,
  Input,
  ViewChild,
} from "@angular/core";
import { MatIconModule } from "@angular/material/icon";
import { Photo } from "@eemo/api-client";
import { SwiperContainer } from "swiper/element";
import { SwiperOptions } from "swiper/types";

export class PhotoExtend {
  photo: Photo;
  categoryName: string;
  url: string;
}

@Component({
  selector: "app-photos-viewer",
  templateUrl: "./photos-viewer.component.html",
  styleUrls: ["./photos-viewer.component.scss"],
  standalone: true,
  imports: [NgFor, SwiperDirective, MatIconModule, TooltipDirective],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class PhotosViewerComponent {
  @ViewChild("swiper") swiper!: ElementRef<SwiperContainer>;
  @ViewChild("swiperThumbs") swiperThumbs!: ElementRef<SwiperContainer>;

  @Input() photos: PhotoExtend[] = [];
  @Input() onClose: () => void = () => {};
  @Input() onComponentUpdate: () => void = () => {};
  private _index = 0;

  @Input()
  set index(index: number) {
    this._index = index;
    this.slideToIndexIfReady();
  }

  imageSizeClass = "";

  // Swiper
  swiperConfig: SwiperOptions = {
    pagination: false,
    thumbs: {
      swiper: ".swiper-thumbs",
    },
    navigation: true,
    spaceBetween: 10,
    loop: true,
    zoom: true,
    on: {
      slideChange: (swiper) => {
        this._index = swiper.activeIndex;
      },
    },
  };

  swiperThumbsConfig: SwiperOptions = {
    spaceBetween: 10,
    slidesPerView: 4,
    freeMode: true,
    watchSlidesProgress: true,
    loop: true,
  };

  constructor() {}

  private slideToIndexIfReady() {
    const swiperEl = this.swiper?.nativeElement;
    if (swiperEl?.swiper && this._index !== 0) {
      swiperEl.swiper.slideTo(this._index);
    }
  }

  toggleRealSize() {
    if (this.imageSizeClass === "") {
      this.imageSizeClass = "real-size";
    } else {
      this.imageSizeClass = "";
    }
    this.onComponentUpdate();
  }
}
